import axios from 'axios';
import cfac22 from '../cfac22';

export function userUpdate(uid, triiboId) {
  return new Promise(function (resolve, reject) {
    axios
      .post(
        cfac22('API_HOST_V1') + 'api_user_update',
        {
          uid: uid,
          inviter: 'pending',
          email: triiboId,
        },
        {
          headers: { access_token: cfac22('ACCESS_TOKEN'), 'Full-Url': window.location.href },
        }
      )
      .then((result) => {
        resolve(result.data.success);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
